import Grid from '@material-ui/core/Grid';
import React from 'react';
import Spinner from 'shared-assets/components/Spinner';
var LoadingUi = function (_a) {
    var isLoading = _a.isLoading;
    return !!isLoading ? (React.createElement(Grid, { container: true, alignItems: "center", justify: "center", item: true, xs: 6 },
        React.createElement(Spinner, { size: "2rem" }),
        " Loading")) : null;
};
export default LoadingUi;
